export const tabKeys = {
  ALL_SHADES: 0,
  BESTSELLERS: 1,
};

export const ALL_SHADES = 'ALL SHADES';
export const BEST_SELLERS = 'BESTSELLERS';
